<template>
  <DialogFull :data="dialogSettings" @close="onClose">
    <div class="container col-md-8 col-sm-12">
      <div class="profile-submitted">
        <div>
          <v-img
            :src="require('@/assets/svg/profile-prompt.svg')"
            class="mb-5"
            height="140"
            contain
          />
          <h2 class="mb-2 d-flex justify-center text-center">
            Do you want to be told about other relevant jobs?
          </h2>
        </div>
        <div class="buttons">
          <PrimaryButton @click.native="openDialog">
            Yes, let me know about other jobs
          </PrimaryButton>
          <PrimaryButton @click.native="onClose" text>
            No thanks
          </PrimaryButton>
        </div>
      </div>
      <ProfilePreferencesDialog :isOpen="isDialogOpen" @close="onClose" />
    </div>
  </DialogFull>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ProfilePreferencesDialog from "@/components/profile/ProfilePreferencesDialog";
import DialogFull from "@/components/common/DialogFull";

export default {
  name: "CreateProfile",
  created() {
    if (this.$route.params.isCreatingProfile) {
      this.openDialog();
    }
  },
  data() {
    return {
      isDialogOpen: false,
      dialogSettings: {
        dialog: true,
        title: "Create Profile"
      }
    };
  },
  components: {
    PrimaryButton,
    ProfilePreferencesDialog,
    DialogFull
  },
  methods: {
    onClose() {
      if (this.$route.params.isCreatingProfile) {
        this.$router.push("settings/profile");
      } else {
        this.$router.push("applications");
      }
    },
    openDialog() {
      this.isDialogOpen = true;
    }
  }
};
</script>

<style lang="scss">
.profile-submitted {
  .buttons {
    display: flex;
    flex-direction: column;
    max-width: 400px;
    margin: 20px auto;
  }
}
</style>
